module.exports = "pegasus_template/assets/theme5/medium/8.jpg";